import React from 'react';
import { Images, ImagePlus, Download } from 'lucide-react';
import MobileCard from '../mobileCard/MobileCard';
import Calendar from '../calendar/Calendar.js';
import ImageGallery from '../imageGallery/ImageGallery.js';
import IframeConfigTab from '../iframeConfig/IframeConfigTab';
import Downloads from '../downloads/Downloads';

// Obra › Archivo Fotográfico: todo lo de las fotos en un solo lugar. "Primera Imagen" y "Descargar imágenes"
// dejaron de estar en el menú Obra y son secciones de acá (los nombres viejos siguen abriendo la sección: ver
// SECCION_DE_PESTANA en CameraDashboard).
export const SECCIONES_ARCHIVO = [
  { id: 'fotos', label: 'Fotos', Icon: Images },
  { id: 'primera', label: 'Primera imagen', Icon: ImagePlus },
  { id: 'descargar', label: 'Descargar imágenes', Icon: Download },
];

export default function ArchivoFotografico({ user, seccion = 'fotos', onSeccion, selectedDate, onDateSelect }) {
  const actual = SECCIONES_ARCHIVO.some((s) => s.id === seccion) ? seccion : 'fotos';
  return (
    <div className="space-y-4 md:space-y-6">
      <div className="flex flex-wrap items-center gap-1.5 sm:gap-2" role="tablist" aria-label="Secciones del archivo fotográfico">
        {SECCIONES_ARCHIVO.map(({ id, label, Icon }) => (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={actual === id}
            onClick={() => onSeccion(id)}
            className={`inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-medium border transition-colors active:scale-95 ${
              actual === id ? 'bg-blue-50 text-blue-700 border-blue-200 shadow-sm' : 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50'
            }`}
          >
            <Icon size={16} aria-hidden="true" />{label}
          </button>
        ))}
      </div>

      {actual === 'fotos' && (
        <>
          <MobileCard>
            <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">Archivo Fotografico</h2>
            <Calendar mode="single" selected={selectedDate} onDateSelect={onDateSelect} user={user} className="w-full max-w-sm mx-auto rounded-md border" />
          </MobileCard>
          <MobileCard>
            <ImageGallery selectedDate={selectedDate} user={user} />
          </MobileCard>
        </>
      )}
      {actual === 'primera' && (
        <MobileCard>
          <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">Primera Imagen</h2>
          <IframeConfigTab user={user} />
        </MobileCard>
      )}
      {actual === 'descargar' && <Downloads user={user} />}
    </div>
  );
}
